import clsx from "clsx";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useImmer } from "use-immer";

import { Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";

import { useGetOrg } from "../../api/organizations/get-organization";
import {
  initSideNavCollapsed,
  setSideNavCollapsed,
} from "../../store/slices/appSettings";
import { IAppState } from "../../store/types/store";

import { OrgPicker } from "./OrgPicker";
import { SideNavBarBody } from "./SideNavBarBody";
import { SideNavBarFooter } from "./SideNavBarFooter";

const drawerWidth = 180;

const PREFIX = "SideNavBar";

const classes = {
  logo: `${PREFIX}-logo`,
  logoPadding: `${PREFIX}-logoPadding`,
  drawer: `${PREFIX}-drawer`,
  drawerOpen: `${PREFIX}-drawerOpen`,
  drawerClose: `${PREFIX}-drawerClose`,
  selected: `${PREFIX}-selected`,
  root: `${PREFIX}-root`,
  selectedCollapse: `${PREFIX}-selectedCollapse`,
  rootCollapse: `${PREFIX}-rootCollapse`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  textMargin: `${PREFIX}-textMargin`,
};

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiPaper-root.MuiDrawer-paper": {
    borderRadius: 0,
  },

  [`&.${classes.drawer}`]: {
    flexShrink: 0,
    whiteSpace: "nowrap",
  },

  [`& .${classes.drawerOpen}`]: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: drawerWidth,
    overflowX: "hidden",
    backgroundColor: "#414448",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  [`& .${classes.drawerClose}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: "#414448",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "50px",
    [theme.breakpoints.up("xs")]: {
      width: parseInt(theme.spacing(7)) - 3,
    },
  },

  [`& .${classes.buttonContainer}`]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  [`& .${classes.textMargin}`]: {
    marginLeft: 15,
  },
}));

export const SideNavBar = () => {
  const organization = useGetOrg();
  const dispatch = useDispatch();

  const sideNavCollapsed = useSelector(
    (state: IAppState) => state.appSettings.sideNavCollapsed
  );

  useEffect(() => {
    if (window.screen.availWidth < 500) {
      dispatch(initSideNavCollapsed(true));
    }
  }, []);
  return (
    <StyledDrawer
      sx={{
        width: !sideNavCollapsed ? drawerWidth : "54px",
      }}
      open={!sideNavCollapsed}
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: !sideNavCollapsed,
        [classes.drawerClose]: sideNavCollapsed,
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: !sideNavCollapsed,
          [classes.drawerClose]: sideNavCollapsed,
        }),
      }}
      variant="permanent"
      anchor="left"
      elevation={0}
    >
      <div>
        <OrgPicker />
        <SideNavBarBody
          drawerOpen={!sideNavCollapsed}
          organization={organization.data.org}
        />
      </div>
      <SideNavBarFooter drawerOpen={!sideNavCollapsed} />
    </StyledDrawer>
  );
};
